import Base from "../base";

export default {
  getHomepage: (link) => Base.get(`/homepage/${link}`),
  getOffertInfo: (cafeId, menuId) => Base.get(`/offert/${cafeId}/${menuId}`),
};
